import Auth from '@/lib/auth/Auth.js'
import toast from '@/lib/cinnamon-toast/CinnamonToast.js'

export default function (error, options) {
  let message = ''
  switch (error.response.status) {
    case 401:
      message = 'Unauthorized.'
      Auth.logout()
      break
    case 403:
      message = 'Forbidden.'
      break
    case 404:
      message = 'Resource not found.'
      break
    case 422:
      message = 'Invaild request.'
      break
    case 400:
      message = 'Bad request. Please contact support.'
      break
    case 500:
      message = 'Whoops, something went wrong. Please try again.'
      break
    default:
  }
  toast(message, { error: true })
  return {
    error: true,
    status: error.response.status,
    message: message,
    body: error.response.data
  }
}
